import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AppAnimations } from 'src/app/_shared/animations';
import { DropDown } from 'src/app/_shared/interfaces/dropdown.interface';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { collectionOfChargeLoyaltyRulesAction, collectionOfChargeLoyaltyRulesAmountTypes, collectionOfChargeLoyaltyRulesEvents, VisibleState, ChargeRulesLoyaltyAction, ChargeLoyaltyRulesAmountTypes, ChargeLoyaltyRulesEvents, ChargeLoyaltyRulesCountType, SubscriptionRuleTypes, SubscriptionRuleStatus, collectionOfChargeLoyaltyRulesCountType, ChargeType } from 'src/app/app.data';
import { DataSharingService, UtilsService } from 'src/app/_core/services';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { ValidatorService } from 'src/app/_shared/validators/validator.service';
import { PUT_LoyaltyRule } from 'src/app/_shared/models/rules.model';
import { PermissionManagerService } from 'src/app/_shared/services/permission/permissions.service';

@Component({
  animations: [AppAnimations],
  selector: 'app-charge-loyalty-rules',
  templateUrl: './charge-loyalty-rules.component.html',
})
export class ChargeLoyaltyRulesComponent implements OnInit, OnDestroy {

  checkedLoyaltyRuleSubscription: boolean = false;
  cleaveNumDecimalOptions: any;
  cleaveNumIntegerOptions: any;
  collectionOfLoyaltyRulesAction: Array<DropDown> = collectionOfChargeLoyaltyRulesAction;
  collectionOfLoyaltyRulesAmountTypes: Array<DropDown> = collectionOfChargeLoyaltyRulesAmountTypes;
  collectionOfLoyaltyRulesEvents: Array<DropDown> = collectionOfChargeLoyaltyRulesEvents;
  collectionOfLoyaltyRulesCountTypes: Array<DropDown> = collectionOfChargeLoyaltyRulesCountType;
  form: FormGroup;
  model: any;

  @Input() _chargeType = ChargeType;
  @Input() _data: any;
  @Input() _selectedChargeType: ChargeType = ChargeType.oneTimeCharge;
  @Input() _visibleState = VisibleState;

  @Output() _emitLoyaltyErrors: EventEmitter<any> = new EventEmitter<any>();
  @Output() _emitLoyaltyRules: EventEmitter<any> = new EventEmitter<any>();

  private subs = new Unsubscriber();


  constructor(
    private _fb: FormBuilder,
    private _shareData: DataSharingService,
    private _validatorService: ValidatorService,
    private utils: UtilsService,
    private permissionS: PermissionManagerService
  ) {
    this.subs.addSub = this._shareData.getSettingsVariables().subscribe(
      ([decimalPlaces, decimalToken, thousandsToken]) => {
        this.cleaveNumDecimalOptions = {
          numeral: true,
          numeralPositiveOnly: true,
          stripLeadingZeroes: false,
          numeralDecimalScale: decimalPlaces,
          delimiter: thousandsToken,
          numeralDecimalMark: decimalToken
        };
        this.cleaveNumIntegerOptions = {
          numeral: true,
          numeralPositiveOnly: true,
          stripLeadingZeroes: false,
          numeralDecimalScale: 0,
          delimiter: thousandsToken,
          numeralDecimalMark: decimalToken
        };
      }
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.setUpForm();
  }

  onChangeLoyaltyRuleSubscription($event) {
    if($event.checked){
      this.form.get('loyaltyRulesAmount').setValidators([Validators.required, this._validatorService.positiveDecimalNumberIncludeZero]);
      this.form.get('loyaltyRulesAmount').updateValueAndValidity();

      this.form.get('loyaltyCount').setValidators([Validators.required, this._validatorService.positiveDecimalNumberExcludeZero, Validators.max(999)]);
      this.form.get('loyaltyCount').updateValueAndValidity();
    } else {
      this.form.get('loyaltyRulesAmount').setValidators([]);
      this.form.get('loyaltyRulesAmount').updateValueAndValidity();
      this.form.get('loyaltyCount').setValidators([]);
      this.form.get('loyaltyCount').updateValueAndValidity();
    }
  }

  setUpForm() {
    this.model = this._data?.ratePlanCharge?.rules?.find(x => x.ruleType == SubscriptionRuleTypes.loyaltyRule);
    this.checkedLoyaltyRuleSubscription = this.model ? true : false;

    this.form = this._fb.group({
      loyaltyAction: [this.model?.action ? this.model.action : ChargeRulesLoyaltyAction.remove],
      loyaltyCount: [this.model?.count ? this.model.count : 4],
      loyaltyCountType: [this.model?.countType ? this.model.countType : ChargeLoyaltyRulesCountType.every],
      loyaltyEvent: [this.model?.event ? this.model.event : ChargeLoyaltyRulesEvents.invoicePosted],
      loyaltyRulesAmount: [this.model?.amount ? this.model.amount : this.utils.formatDecimalNumberToReceive(1)],
      loyaltyRulesAmountType: [this.model?.amountType ? this.model.amountType : ChargeLoyaltyRulesAmountTypes.price],
      loyaltyRulesEnabled: [this.checkedLoyaltyRuleSubscription]
    });

    if (this._data.inlineEdit) {
      this.form.get('loyaltyRulesAmount').setValue(this.utils.formatDecimalNumberToReceive(this.form.get('loyaltyRulesAmount').value));
    }

    if(this.checkedLoyaltyRuleSubscription) {
      this.form.get('loyaltyRulesAmount').setValidators([Validators.required, this._validatorService.positiveDecimalNumberIncludeZero]);
      this.form.get('loyaltyRulesAmount').updateValueAndValidity();
      this.form.get('loyaltyCount').setValidators([Validators.required, this._validatorService.positiveDecimalNumberExcludeZero, Validators.max(999)]);
      this.form.get('loyaltyCount').updateValueAndValidity();
    }

    this.permissionS.checkInput('feature_loyaltydiscount|enabled|SCOPE_SET_VALUE', this.form, 'loyaltyRulesEnabled');
  }

  setBodyParams() {
    if(this.form.get('loyaltyRulesEnabled').value) {
      if (this.form.invalid) {
        this.form.markAllAsTouched();
        this.form.markAsDirty();
        this._emitLoyaltyErrors.emit(true);
        return;
      }

      let bodyParams: PUT_LoyaltyRule = {
        action: this.form.get('loyaltyAction').value,
        amount:  this.utils.convertToNumber(this.form.get('loyaltyRulesAmount').value),
        amountType: this.form.get('loyaltyRulesAmountType').value,
        count: this.utils.convertToNumber(this.form.get('loyaltyCount').value),
        countType: ChargeLoyaltyRulesCountType.every,
        event: this.form.get('loyaltyEvent').value,
        ruleType: SubscriptionRuleTypes.loyaltyRule,
        status: SubscriptionRuleStatus.active

      };

      this._emitLoyaltyRules.emit([bodyParams]);
    } else {
      this._emitLoyaltyRules.emit([]);
    }

  }

}
